import React from 'react';
import { Col, Form, Row } from "react-bootstrap";
import { useSelector, useDispatch } from 'react-redux';

import messages from '../../assets/i18n'

export default function ProviderFilter() {

  const dispatch = useDispatch();

  const lang = useSelector(state => state.language.name);
  const filters = useSelector(state => state.provider.filter);

  const setFilters = (newFilters) => {
    dispatch({
      type: 'SET_PROVIDER_FILTER',
      filter: newFilters
    })
  };

  const onEnterFilter = (e) => {
    if (e.keyCode === 13) {
      dispatch({
        type: 'GET_PROVIDERS',
        filter: filters
      })
    }
  }

  return (
    <Form className="px-3">
      <Row>
        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{messages[lang].nome}</Form.Label>
                <Form.Control
                    className="text-2 border-radius-full"
                    placeholder={messages[lang].nome}
                    type="text"
                    defaultValue={filters.nome}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                        { ...filters, nome: event.target.value },
                    )}
                />
        </Form.Group>

        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{messages[lang].cnpj}</Form.Label>
                <Form.Control
                    className="text-2 border-radius-full"
                    placeholder={messages[lang].cnpj}
                    type="text"
                    defaultValue={filters.cnpj}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                    { ...filters, cnpj: event.target.value },
                    )}
                />
        </Form.Group>
      </Row>
    </Form>
  );
}
